import { styled } from 'styled-components'
import { Block } from 'suomifi-ui-components'

export const Divider = styled(Block)`
  padding-top: ${({ theme }) => theme.spacing.xs};
  border-bottom: 1px solid #6b6b6b;
`

export const LeftAndRightBlock = styled(Block)`
  margin: ${({ theme }) => theme.spacing.s} 0;
  display: flex;
  justify-content: space-between;
`
